export default __webpack_public_path__ + "static/media/infografika.25106c59.webp";